import { render, staticRenderFns } from "./ChamaileonEmailTemplateEditor.vue?vue&type=template&id=3839873e&scoped=true&"
import script from "./ChamaileonEmailTemplateEditor.vue?vue&type=script&lang=ts&"
export * from "./ChamaileonEmailTemplateEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ChamaileonEmailTemplateEditor.vue?vue&type=style&index=0&id=3839873e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3839873e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBreadcrumbs,VBtn,VCardActions,VCardText,VCardTitle,VCol,VContainer,VForm,VIcon,VRow,VSpacer,VTextField})
